export const API_BASE = process.env.REACT_APP_BACKEND_URL || "";
export const API = `${API_BASE}/api`;